import React from 'react';

import InformationIcon from '@atlaskit/icon/core/information-circle';
import { Flex } from '@atlaskit/primitives/compiled';

export const DetailsPanelHeaderIcon = () => {
	return (
		<Flex alignItems="center">
			<InformationIcon label="" />
		</Flex>
	);
};
